// extracted by mini-css-extract-plugin
export default {"upper-section":"SignInPage_upper-section__CGS1t","body":"SignInPage_body__JotYX"};